module.exports = __webpack_public_path__ + "img/delect.ccbb5bec.png";